
export default {
    name: 'FoldersMixin',
    methods: {
        createFolder (name, folder) {
            return this.$axios.post(this.localePath('/v1/fs/nodes'), { name, folder, type: 'd' })
        },
        getNode (node, params) {
            const endPoint = this.localePath('/v1/fs/nodes/' + node.id)
            return this.$axios.get(endPoint, { params })
        },
        listNodes (id, params) {
            const endPoint = this.localePath('/v1/fs/nodes')
            return this.$axios.get(endPoint, { params: Object.assign({ ...params }, { folder: id || undefined }) })
        },
        pushNodes (id, params, method = 'push') {
            return new Promise((resolve, reject) => {
                this.$router[method](
                    this.localePath({ path: '/Folders' + (id ? '/' + id : ''), query: params }),
                    route => resolve(route),
                    err => reject(err)
                )
            })
        }
    }
}
